
import { useCallback } from 'react';
import { toast } from 'sonner';
import { logger } from '@/utils/logger';
import { formatError } from '@/utils/formatError';

export const useErrorHandler = () => {
  const handleError = useCallback((error: Error, context: string, userMessage?: string) => {
    logger.error(`Error in ${context}:`, error);
    toast.error(userMessage ?? formatError(error));
  }, []);

  const handleAsyncError = useCallback(async <T>(
    asyncFn: () => Promise<T>,
    context: string,
    userMessage?: string
  ): Promise<T | null> => {
    try {
      return await asyncFn();
    } catch (error) {
      handleError(error as Error, context, userMessage);
      return null;
    }
  }, [handleError]);

  return { handleError, handleAsyncError };
};
